import { useEffect, useRef } from 'react'

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

export default function GoogleBtn({ onCredential, label = 'continue_with' }) {
  const ref = useRef(null)

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) return
    let attempts = 0
    const tryRender = () => {
      if (window.google?.accounts?.id && ref.current) {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: ({ credential }) => onCredential(credential)
        })
        window.google.accounts.id.renderButton(ref.current, {
          theme: 'outline', size: 'large',
          width: ref.current.offsetWidth || 360, text: label
        })
      } else if (attempts++ < 20) {
        setTimeout(tryRender, 200)
      }
    }
    tryRender()
  }, [GOOGLE_CLIENT_ID])

  if (!GOOGLE_CLIENT_ID) return (
    <div className="w-full rounded-xl border border-dashed border-gray-300 py-3 text-center text-xs text-gray-400">
      Google sign-in not enabled — set VITE_GOOGLE_CLIENT_ID
    </div>
  )
  return <div ref={ref} className="w-full flex justify-center min-h-[44px]" />
}
